// HomeBrands.jsx
import React from "react";
import "./../../css/HomeBrands.css";
import { Brand1 } from "../../assets/images";
import { Brand2 } from "../../assets/images";
import { Brand3 } from "../../assets/images";
import { Brand4 } from "../../assets/images";
import { Brand5 } from "../../assets/images";
import { Brand6 } from "../../assets/images";

const HomeBrands = () => {
  return (
    <div className='brands-grid'>
      {BRANDS.map((item) => (
        <ItemBrand key={item} src={item} />
      ))}
    </div>
  );
};

const BRANDS = [Brand1, Brand2, Brand3, Brand4, Brand5, Brand6];

const ItemBrand = ({ src }) => {
  return (
    <div className='brand-item'>
      <img src={src} className='brand-img' alt='Brand' />
    </div>
  );
};

export default HomeBrands;
